import React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export type PatientsIconProps = SvgIconProps

export function PatientsIcon(props: PatientsIconProps) {
  const { htmlColor } = props
  return (
    <SvgIcon width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="My_patients">
        <g>
          <g id="XMLID_00000163031447314687219940000004193877302469382311_">
            <g>
              <path
                style={{ fill: htmlColor || '#A7A9AC' }}
                d="M144.609,154.818c0,0,0,21.16-0.03,23.39c-7.73,4.41-16.17,7.71-25.11,9.68
					c-6.27,1.38-12.79,2.11-19.47,2.11c-0.19,0-0.39,0-0.58-0.01l0.02-1.3v-59.01v-0.97h1.02v0.01l16.4,8.4l1.34-14.89v-0.02
					c0.07,0.01,0.15,0.03,0.23,0.05c1.08,0.17,2.13,0.41,3.16,0.69c0,0,1.47,0.38,2.89,0.9c11.11,4,16.36,13.76,16.36,13.76
					C142.369,141.008,144.559,147.048,144.609,154.818z"
              />
              <path
                style={{ fill: htmlColor || '#A7A9AC' }}
                d="M125.179,79.338c-0.52,1.03-1.05,1.91-1.54,2.63c-2.62-0.97-5.79-2.41-9.14-4.57
					c-2.67-1.71-4.85-3.5-6.59-5.11c-0.2,1.16-0.36,2.88-0.04,4.93c0.28,1.84,0.86,3.3,1.34,4.3c-3.05,0.2-10.05,0.24-17.47-3.76
					c-5.53-2.98-8.92-6.92-10.66-9.29c-1.05,1.5-2.22,3.48-3.21,5.94c-1.34,3.31-1.84,6.29-2.04,8.48
					c-0.39-0.53-1.27-1.78-2.14-3.56c-1.43-2.94-2.81-7.33-1.84-12.33c1.27-6.62,5.94-10.54,8.95-13.08
					c4.03-3.39,8.11-5.06,10.76-5.91c-0.2-1.59-0.39-3.17-0.58-4.75c1.27,0.03,2.72,0.15,4.3,0.4c1.72,0.28,3.26,0.67,4.57,1.08
					c0.24-0.79,0.75-2.1,1.88-3.36c1.59-1.79,3.47-2.45,4.3-2.69c-0.12,0.6-0.36,2.21,0.4,4.03c0.73,1.73,1.95,2.68,2.47,3.03
					c3.2,1.84,5.7,3.64,7.48,5.04c2.52,1.97,5.25,4.14,7.4,7.29c1.6,2.35,2.5,4.68,2.61,4.95c0.49,1.24,0.65,2,0.65,2
					c0.43,2.13,0.89,6.04-0.42,10.6C126.219,77.028,125.709,78.268,125.179,79.338z"
              />
              <path
                style={{ fill: htmlColor || '#A7A9AC' }}
                d="M99.439,129.678v59.01l-0.02,1.3c-16.5-0.1-31.94-4.64-45.2-12.49l0.06-0.1v-22.58
					c0.04-7.77,2.24-13.81,3.77-17.21c0,0,5.24-9.76,16.36-13.76c1.42-0.52,2.88-0.9,2.88-0.9c1.03-0.28,2.09-0.52,3.16-0.69
					c0.09-0.02,0.17-0.04,0.24-0.05v0.02l1.34,14.89l16.4-8.4v-0.01h1.01V129.678z"
              />
            </g>
            <g>
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M54.219,177.498c-26.47-15.67-44.22-44.51-44.22-77.5c0-49.7,40.3-90,90-90c49.71,0,90,40.3,90,90
					c0,33.48-18.29,62.7-45.42,78.21c-7.73,4.41-16.17,7.71-25.11,9.68c-6.27,1.38-12.79,2.11-19.47,2.11c-0.19,0-0.39,0-0.58-0.01
					C82.919,189.888,67.479,185.348,54.219,177.498z"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M74.239,92.798c-0.42-2.15-3.21-1.32-4.43-6.38c-1.77-7.34,1.78-8.51,3.88-7.09c0.02,0.01,0.03,0.02,0.05,0.03"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M124.639,92.798c0.43-2.15,3.22-1.32,4.43-6.38c1.77-7.37-1.8-8.52-3.89-7.08c-0.01,0.01-0.02,0.01-0.03,0.02"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M74.249,92.798c2.36,15.71,12.74,27.54,25.2,27.54c12.45,0,22.83-11.83,25.19-27.54"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M106.599,90.188c0.32,0.24,1.43,1.05,3.06,1.01c1.47-0.04,2.48-0.76,2.81-1.01"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M92.279,90.188c-0.31,0.24-1.43,1.05-3.05,1.01c-1.48-0.04-2.48-0.76-2.81-1.01"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M104.999,110.088c-1.72-1.3-3.61-2.05-5.55-2.05c-1.95,0-3.84,0.75-5.56,2.05"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M125.179,79.338c0.53-1.07,1.04-2.31,1.44-3.71c1.31-4.56,0.85-8.47,0.42-10.6c0,0-0.16-0.76-0.65-2
					c-0.11-0.27-1.01-2.6-2.61-4.95c-2.15-3.15-4.88-5.32-7.4-7.29c-1.78-1.4-4.28-3.2-7.48-5.04c-0.52-0.35-1.74-1.3-2.47-3.03
					c-0.76-1.82-0.52-3.43-0.4-4.03c-0.83,0.24-2.71,0.9-4.3,2.69c-1.13,1.26-1.64,2.57-1.88,3.36c-1.31-0.41-2.85-0.8-4.57-1.08
					c-1.58-0.25-3.03-0.37-4.3-0.4c0.19,1.58,0.38,3.16,0.58,4.75c-2.65,0.85-6.73,2.52-10.76,5.91c-3.01,2.54-7.68,6.46-8.95,13.08
					c-0.97,5,0.41,9.39,1.84,12.33c0.87,1.78,1.75,3.03,2.14,3.56c0.2-2.19,0.7-5.17,2.04-8.48c0.99-2.46,2.16-4.44,3.21-5.94
					c1.74,2.37,5.13,6.31,10.66,9.29c7.42,4,14.42,3.96,17.47,3.76c-0.48-1-1.06-2.46-1.34-4.3c-0.32-2.05-0.16-3.77,0.04-4.93
					c1.74,1.61,3.92,3.4,6.59,5.11c3.35,2.16,6.52,3.6,9.14,4.57C124.129,81.248,124.659,80.368,125.179,79.338z"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M98.139,128.708h0.29h1.01h1.02h0.3c6.58,0,12.6-2.47,17.14-6.56c0.1,0.01,0.2,0.03,0.3,0.06c0.07,0.01,0.15,0.03,0.23,0.05
					c1.08,0.17,2.13,0.41,3.16,0.69c0,0,1.47,0.38,2.89,0.9c11.11,4,16.36,13.76,16.36,13.76c1.53,3.4,3.72,9.44,3.77,17.21
					c0,0,0,21.16-0.03,23.39c0,0.12,0,0.19,0,0.19"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M54.279,177.398v-22.58c0.04-7.77,2.24-13.81,3.77-17.21c0,0,5.24-9.76,16.36-13.76c1.42-0.52,2.88-0.9,2.88-0.9
					c1.03-0.28,2.09-0.52,3.16-0.69c0.09-0.02,0.17-0.04,0.24-0.05c0.11-0.03,0.2-0.05,0.3-0.06"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M80.989,122.148c4.55,4.07,10.56,6.56,17.15,6.56"
              />

              <polyline
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                points="
					98.429,128.718 82.029,137.118 80.689,122.228 				"
              />

              <polyline
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                points="
					100.459,128.718 116.859,137.118 118.199,122.228 				"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="99.439"
                y1="188.688"
                x2="99.439"
                y2="129.678"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="71.489"
                y1="152.118"
                x2="71.489"
                y2="185.238"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="127.399"
                y1="152.118"
                x2="127.399"
                y2="185.238"
              />
            </g>
          </g>
        </g>
      </g>
      <g id="Layer_1"></g>
    </SvgIcon>
  )
}

export default PatientsIcon
